import { render, staticRenderFns } from "./Variation.vue?vue&type=template&id=1287ce20"
import script from "./Variation.vue?vue&type=script&lang=js"
export * from "./Variation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports